import styled from 'styled-components';
import { CurrencyLevel } from 'economy';
import { ThumbnailScroller } from '../Conversation/styles';

// Shared styles for ChatInput components (Scene and DS)

interface BaseProps {
	isMobile?: boolean;
}

export const Base = styled.div<BaseProps>`
	// layout
	bottom: 0;
	left: 0;
	right: 0;
	padding: ${({ isMobile }) => (isMobile ? '16px' : '12px')};
	display: flex;
	flex-direction: column;

	// style
	border-top: 1px solid ${({ theme }) => theme.gray[200]};
	gap: ${({ isMobile }) => (isMobile ? '12px' : '8px')};
	background-color: ${({ theme }) => theme.gray[0]};
`;

interface PromptProps {
	isFocused: boolean;
}

export const Prompt = styled.div<PromptProps>`
	// layout
	width: 100%;

	// style
	background-color: ${({ theme }) => theme.gray[100]};
	border-radius: 4px;
	border: ${({ isFocused, theme }) =>
		isFocused ? `1px solid ${theme.gray[400]}` : '1px solid transparent'};
`;

interface MultilineInputWrapperProps {
	isMobile?: boolean;
}

export const MultilineInputWrapper = styled.div<MultilineInputWrapperProps>`
	max-height: ${({ isMobile }) => (isMobile ? '150px' : '35vh')};
	overflow-y: auto;
	scrollbar-width: thin;
	scrollbar-color: ${({ theme }) => theme.gray[400]} ${({ theme }) => theme.gray[100]};
	border-radius: 4px;

	&::-webkit-scrollbar {
		width: 6px;
	}

	&::-webkit-scrollbar-track {
		background: ${({ theme }) => theme.gray[100]};
	}

	&::-webkit-scrollbar-thumb {
		background-color: ${({ theme }) => theme.gray[400]};
		border-radius: 3px;
	}
`;

interface ActionsProps {
	isMobile?: boolean;
}

export const Actions = styled.div<ActionsProps>`
	padding: ${({ isMobile }) => (isMobile ? '12px' : '4px')};
	padding-left: ${({ isMobile }) => (isMobile ? '12px' : '4px')};
	padding-right: ${({ isMobile }) => (isMobile ? '12px' : '4px')};
	display: flex;
	justify-content: ${({ isMobile }) => (isMobile ? 'flex-start' : 'flex-end')};
	align-items: center;
	gap: ${({ isMobile }) => (isMobile ? '10px' : '4px')};
`;

export const Attachments = styled(ThumbnailScroller)`
	// layout
	display: flex;
	margin-top: 8px;
	margin-left: 4px;
	margin-right: 4px;
`;

export const GenerationOptions = styled.div`
	// layout
	display: flex;
	gap: 8px;
	align-items: center;
`;

export const Spacer = styled.div`
	flex: 1;
`;

export const LilWidthSpacer = styled.div`
	width: 2px;
`;

interface WrapperProps {
	isMobile?: boolean;
}

export const SubmitButtonWrapper = styled.div<WrapperProps>`
	padding-top: ${({ isMobile }) => (isMobile ? '6px' : '4px')};
	padding-bottom: ${({ isMobile }) => (isMobile ? '6px' : '0')};
	padding-right: ${({ isMobile }) => (isMobile ? '2px' : '0')};
	transform: ${({ isMobile }) => (isMobile ? 'scale(1.5)' : 'scale(1)')};
	transform-origin: center;
`;

export const LoadingWrapper = styled.div<WrapperProps>`
	padding-top: ${({ isMobile }) => (isMobile ? '6px' : '4px')};
`;

interface MobileToastProps {
	isVisible: boolean;
}

export const MobileToast = styled.div<MobileToastProps>`
	position: fixed;
	top: calc(env(safe-area-inset-top, 0px) + 12px);
	left: 50%;
	transform: translateX(-50%);
	max-width: 90vw;
	background-color: ${({ theme }) => theme.gray[1000]};
	color: ${({ theme }) => theme.gray[0]};
	padding: 12px 18px;
	border-radius: 999px;
	box-shadow: 0 12px 24px rgba(0, 0, 0, 0.25);
	opacity: ${({ isVisible }) => (isVisible ? 1 : 0)};
	transition: opacity 0.2s ease;
	font-family: Inter;
	font-size: 16px;
	font-weight: 500;
	line-height: 1.4;
	text-align: center;
	pointer-events: none;
	z-index: 999;
`;

interface GoldIndicatorWrapperProps {
	walletLevel?: CurrencyLevel;
}

export const GoldIndicatorWrapper = styled.div<GoldIndicatorWrapperProps>`
	position: relative;
	padding: 2px 3px;
	display: flex;
	align-items: center;
	justify-content: center;
	transition: all 0.2s ease;
	border-radius: 5px;
`;

interface GoldCircleProps {
	walletLevel?: CurrencyLevel;
}

export const GoldCircle = styled.div<GoldCircleProps>`
	width: 14px;
	height: 14px;
	border-radius: 50%;
	border: 2.5px solid ${({ theme }) => theme.gray[200]};
	background-color: #ffeaa7;
	transition: all 0.2s ease;
	position: relative;
	opacity: ${({ walletLevel }) => (walletLevel === 'EMPTY' ? 0.4 : 1)};
`;

export const ErrorIconOverlay = styled.div`
	position: absolute;
	top: 0px;
	right: 0px;
	width: 14px;
	height: 14px;
	border-radius: 50%;
	display: flex;
	align-items: center;
	justify-content: center;
	z-index: 1;
`;
